import { errorMapper } from '../mappers/error-mapper';
import { subscriptionPlanMapper } from '../mappers/subscription-plan-mapper';
import { apiClient } from '../shared/api-client';

const subscriptionRepository = {
    async getPlans(languageCode) {
        try {
            const plans = await apiClient.get({
                url: 'subscriptions/plans',
                params: languageCode ? { languageCode } : undefined
            });

            return plans.map(subscriptionPlanMapper.toDomain).filter(Boolean);
        } catch {
            return [];
        }
    },

    async createForm(body) {
        try {
            const plan = await apiClient.post({
                url: 'subscriptions/form',
                body
            });

            return plan;
        } catch (error) {
            throw errorMapper.toDomain(error);
        }
    },

    async createWithToken(body) {
        const status = await apiClient.post({
            url: 'subscriptions/with-token',
            body
        });

        return status;
    },

    async getStatus(subscriptionId) {
        try {
            return await apiClient.get({
                url: `subscriptions/${subscriptionId}/status`
            });
        } catch {
            return null;
        }
    }
};

export {
    subscriptionRepository
};
